export function isRunByJest(): boolean {
    return typeof process.env.JEST_WORKER_ID !== 'undefined';
}
